import { FormStore, FormValidator } from '@estee/elc-form';
import {
  action, observable, computed,
} from 'mobx';

export interface ICreditCardFormStoreAttributes {
  cardHolderName?: string;
  cardNumber: string;
  cardType: string;
  cvv: string;
  expMonth: number;
  expYear: number;
  installments?: number;
  shouldSaveCC: boolean;
  shouldMakeDefaultCard: boolean;
}

class CreditCardFormStore extends FormStore<ICreditCardFormStoreAttributes> {
  @observable globalError: string;

  @observable cardHolderNameError: string;

  constructor() {
    super({
      formValidator: new FormValidator(),
      initialValues: {
        cardHolderName: '',
        cardNumber: '',
        cardType: '',
        cvv: '',
        expMonth: 0,
        expYear: 0,
        installments: 1,
        shouldMakeDefaultCard: false,
        shouldSaveCC: false,
      },
    });
  }

  @action
  public updateCreditCardValues(
    crediCardFormValues: Partial<ICreditCardFormStoreAttributes>,
  ): void {
    this.setValues({
      ...this.values,
      ...crediCardFormValues,
    });
  }

  @action
  setCardHolderNameError(error: string): void {
    this.cardHolderNameError = error;
  }

  @action
  setGlobalError(error: string): void {
    this.globalError = error;
  }

  @computed
  get isValidCCForm(): boolean {
    return !(this.globalError || this.cardHolderNameError);
  }
}

export default CreditCardFormStore;
